
import React, { useContext, useState } from 'react'

const VehiclesContext = React.createContext()
const { Provider } = VehiclesContext

const defaultVehiclesState =
{
	searchRequest:
	{
		pageIndex: 0,
		pageSize: 15,
		serialNumber: '',
		make: '',
		models: []
	},
	backRoute: '',
	vehicleDisclosures: []
}

const VehiclesProvider = props =>
{
	const [searchRequest, setSearchRequest] = useState(defaultVehiclesState.searchRequest)
	const [backRoute, setBackRoute] = useState('')
	const [vehicleDisclosures, setVehicleDisclosures] = useState(defaultVehiclesState.vehicleDisclosures)
	
	return <Provider value={{
		searchRequest,
		setSearchRequest,
		backRoute,
		setBackRoute,
		vehicleDisclosures,
		setVehicleDisclosures
	}}>{ props.children }</Provider>
}

export { VehiclesProvider, VehiclesContext }
